import React from 'react';

import {
  Actions as UIActions,
  Action,
  ViewColumnIcon,
  FileDownloadIcon,
  FormatColorFillOutlinedIcon,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';

const Actions = ({
  onExport,
  onCustomizeColumns,
  disabledCustomizeColumns,
  disabledExport,
  colorScaled,
  onToggleColorScales,
}) => {
  return (
    <UIActions>
      <Action
        icon={<FormatColorFillOutlinedIcon />}
        onClick={onToggleColorScales}
        label={`${colorScaled ? 'Hide' : 'Show'} color scales`}
        componentProps={colorScaled ? { crossed: true } : {}}
      />
      <Action
        icon={<ViewColumnIcon />}
        label={'Customize columns'}
        onClick={onCustomizeColumns}
        disabled={disabledCustomizeColumns}
      />

      <Action component={FullScreenToggler} />
      <Action
        label={'Export'}
        icon={<FileDownloadIcon />}
        onClick={onExport}
        disabled={disabledExport}
      />
    </UIActions>
  );
};

export default Actions;
